import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import driverinfosecurity from '../../utils/DriverInfoSecurity';

export default function Logout(_props: RouteComponentProps<{}>) {
    driverinfosecurity.logout();
    return <Redirect to={'/login'} />;
}
